import React from 'react';

import styles from './style.module.css';
import {usePathname, useRouter} from '@/hooks/useAppRouter';
import type {Icon} from '@phosphor-icons/react';
import {classes} from '@/util';

interface NavItemProps {
    icon: Icon;
    id: string;
    label: string;
}

export function NavItem({
    id,
    label,
    icon: IconComponent,
}: NavItemProps): React.ReactElement {
    const router = useRouter();
    const pathname = usePathname();
    const isActive =
        pathname.startsWith(`/${id}`) ||
        (id === 'dashboard' && pathname === '/');

    const targetPath = id === 'dashboard' ? '/' : `/${id}`;

    function handleClick() {
        router.push(targetPath);
    }

    function handleKeyDown(event: React.KeyboardEvent) {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            handleClick();
        }
    }

    return (
        <div
            role="link"
            tabIndex={0}
            aria-current={isActive ? 'page' : undefined}
            data-id={id}
            onClick={handleClick}
            onKeyDown={handleKeyDown}
            className={classes(styles.navItem, {
                [styles.active]: isActive,
            })}
        >
            <div className={styles.icon}>
                <IconComponent size={24} weight="regular" />
            </div>
            <span className={styles.label}>{label}</span>
        </div>
    );
}
